// The expanded composer reserves extra top room for the caret, but an
// attachment row already sits above the textarea, so it drops back to pt-2.
export const chatInputPaddingClasses = ({
	isMultiLine,
	hasAttachments,
}: {
	isMultiLine: boolean
	hasAttachments: boolean
}) => {
	if (!isMultiLine) return "py-1.5"
	return hasAttachments ? "pb-2 pt-2" : "pb-2 pt-4"
}

// The textarea and the attachment row share one inset, so a thumbnail starts
// on the same line as the first character of the message.
export const CHAT_INPUT_TEXT_INSET_CLASS = "px-2"

export const CHAT_INPUT_ATTACHMENTS_CLASSES = `mb-2 py-0.5 ${CHAT_INPUT_TEXT_INSET_CLASS}`
